<template>
    <div class="particle-container">
        <animated-crosshairs v-if="props.animate" />
    </div>
</template>

<script setup lang="ts">
import AnimatedCrosshairs from '@/components/deltaGpt/Crosshairs/AnimatedCrosshairs.vue';

const props = defineProps<{
    animate: boolean;
}>();

</script>
<style lang="scss" scoped>
.particle-container {
    background-image: url('@/assets/imgs/crosshairs-temp.png');
    background-size: 50%;
    background-repeat: no-repeat;
    background-position: bottom right;
    overflow: hidden;
    position: relative;
    height: 100%;
    width: 100%;
}
</style>
